import { useGetRetailerConfigurationQuery } from 'domains/merchandising/api'

export const useGetRetailerConfiguration = ({ retailerId }) => {
  const { data, error, loading } = useGetRetailerConfigurationQuery({
    variables: {
      id: retailerId,
    },
  })

  const retailerConfiguration = data?.retailer

  return {
    retailerConfiguration,
    result: data,
    success: Boolean(data),
    loading: loading,
    error: error,
  }
}
